export class ResendEmail {
  email: string;
}
